// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "SectionBackgroundImageLeft-module--backgroundContainmentImage--6c3d5";
export var content = "SectionBackgroundImageLeft-module--content--2bdd5";
export var contentWrapper = "SectionBackgroundImageLeft-module--contentWrapper--a7346";
export var ctaBtn = "SectionBackgroundImageLeft-module--ctaBtn--c10a4";
export var heading = "SectionBackgroundImageLeft-module--heading--43123";
export var headingWrapper = "SectionBackgroundImageLeft-module--headingWrapper--09fd7";
export var wrapper = "SectionBackgroundImageLeft-module--wrapper--35695";